import {
  UPDATE_FEE_REDUCER_DATA,
  ADD_FEE,
  UPDATE_FEE_DATA,
  UPDATE_HOME_REDUCER,
  UPDATE_MENU_MODEL,
  UPDATE_FEE_BUNDLE,
  UPDATE_FEE,
} from "../actions";

const INITIAL_STATE = {
  isLoading: false,
  fees: [],
  feeBundles: [],
  feeAccounts: [],
  createdFeeDetails: [],
  campuses: [],
  classrooms: [],
  students: [],
  dashboardData: [],
  studentsList: [],
  gstDetails: [],
  departments: [],
  courses: [],
  electives: [],
  isHigherEducationInstitute: null,
  feeBundleUpdateLoader: false,
  feeUpdateLoader: false,
  isMenuBar: false,
  isAdmin: false,
  isLocked: false,
  paymentChanges: [],
  institutesTags: [],
  institutesTagGroups: [],
  tagsData: [],
};

const getIndex = (lists, id) => {
  return lists.map((list) => list.id).indexOf(id);
};

const updateFeeBundle = ({ feeBundles }, response) => {
  const index = getIndex(feeBundles, response.feeBundleId);
  feeBundles[index].name = response.feeBundleName;
  return { feeBundles: [...feeBundles] };
};

const updateFee = ({ feeDetails }, response) => {
  const index = getIndex(feeDetails, response.feeId);
  feeDetails[index].name = response.name;
  feeDetails[index].tax = parseFloat(response.tax);
  feeDetails[index].total_amount = parseFloat(response.total_amount);
  feeDetails[index].due_date = response.due_date;
  feeDetails[index].priority = parseInt(response.priority, 10);
  feeDetails[index].fee_account_id = response.fee_account_id;
  feeDetails[index].amount = response.total_amount / (1 + response.tax / 100);
  return { feeDetails: [...feeDetails] };
};

const homeReducer = (state = INITIAL_STATE, action) => {
  let newState = state;
  let fee = {},
    feeIndex = -1;
  switch (action.type) {
    case UPDATE_FEE_REDUCER_DATA:
      return { ...newState, ...action.payload };
    case ADD_FEE:
      fee = action.payload.feeDetails;
      newState.createdFeeDetails = [fee, ...newState.createdFeeDetails];
      return { ...newState };
    case UPDATE_FEE_DATA:
      feeIndex = -1;
      newState.createdFeeDetails.filter((fee, index) => {
        if (fee.id === action.payload.feeId) {
          feeIndex = index;
          return 1;
        }
      });
      newState.createdFeeDetails[feeIndex] = action.payload.feeDetails;
      return { ...newState };
    case UPDATE_HOME_REDUCER:
      return { ...state, ...action.payload };
    case UPDATE_MENU_MODEL: {
      return { ...state, isMenuBar: !state.isMenuBar };
    }
    case UPDATE_FEE_BUNDLE:
      return { ...state, ...updateFeeBundle(state, action.payload) };
    case UPDATE_FEE:
      return { ...state, ...updateFee(state, action.payload) };
    default:
      return state;
  }
};

export default homeReducer;
